import { Box, Grid, makeStyles, Typography } from '@material-ui/core'
import React from 'react'
import Image from '../../../shared/Image'
import makeConduiitImage from '../../../assets/images/illustrations/makeConduiitImage.png'

const useStyles = makeStyles((theme) => ({
  conduiitBox: {
    '& .lazy-load-image-background': {
      verticalAlign: 'bottom',
      marginTop: '-100px',
      [theme.breakpoints.down('sm')]: {
        marginTop: 0,
      },
    },
  },
  conduiitText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: '50px 0',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      padding: '120px 0 87px',
    },
    '& h3': {
      fontSize: 48,
      fontWeight: 800,
      color: theme.palette.common.white,
      marginBottom: 30,
      [theme.breakpoints.down('md')]: {
        marginBottom: 19,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: 36,
      },
    },
    '& p': {
      fontSize: 20,
      fontWeight: 400,
      color: theme.palette.common.white,
      [theme.breakpoints.down('xs')]: {
        fontSize: 18,
      },
    },
  },
  conduiitBoxImage: {
    [theme.breakpoints.down('md')]: {
      maxWidth: '80%',
      marginLeft: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '93%',
    },
  },
}))

const MakeConduiit = () => {
  const classes = useStyles()

  return (
    <>
      <Box className={classes.conduiitBox}>
        <Grid container justifyContent="center" alignItems="center">
          <Grid item sm={6}>
            <Box className={classes.conduiitText}>
              <Box>
                <Typography variant="h3">Make Conduiit yours</Typography>
                <Typography variant="body1">
                  Customize the look of and feel of Conduiit <br /> to match
                  your brand.{' '}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item md={6}>
            <Box className={classes.conduiitBoxImage}>
              <Image src={makeConduiitImage} />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default MakeConduiit
